function custom_addtocart(product, open_drawer) {
  let addedResponse;
  console.log(product);
  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(product)
  })
    .then(response => response.json())
    .then(response => {
      addedResponse = response;
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(async () => {
      if (open_drawer) {
        const this_cartDrawer = document.querySelector('cart-drawer');
        await this_cartDrawer.refresh(true);
      }
      if (addedResponse && !addedResponse.status) {
        document.dispatchEvent(new CustomEvent('shark:cart-added', { detail: { cartData: addedResponse } }));
      }
    });
}

function collection_filter() {
    const open_buttons = document.querySelectorAll("[dara-filter-open-cust]");

    open_buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
            e.stopPropagation();

            const filterBlock = button
                .closest('#FacetFiltersForm')
                .querySelector("[data-filter-main-blocks]");

            filterBlock.classList.toggle('show-cust-filter');
            document.body.classList.toggle('open-cust-filter');
        });
    });

    document.addEventListener("click", (e) => {
        const filterBlock = document.querySelector("[data-filter-main-blocks]");

        if (
            filterBlock &&
            !e.target.closest("[data-filter-main-blocks]") &&
            !e.target.closest("[dara-filter-open-cust]")
        ) {
            filterBlock.classList.remove("show-cust-filter");
            document.body.classList.remove("open-cust-filter");
        }
    });
}

const tabs = document.querySelectorAll('[data-tab-target]');
const tabContents = document.querySelectorAll('[data-tab-content]');

tabs.forEach((tab) => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget);
    tabContents.forEach((tabContent) => {
      tabContent.classList.remove('active');
    });
    tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    tab.classList.add('active');
    target.classList.add('active');
  });
});


// Footer Accordion JS Start
const accSingleTriggers = document.querySelectorAll('[js-acc-single-trigger]');

  accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
  
  function toggleAccordion() {
    const items = document.querySelectorAll('[js-acc-item]');
    const thisItem = this.parentNode;
  
    items.forEach(item => {
      if (thisItem == item) {
        thisItem.classList.toggle('is-open');
        return;
      }
      item.classList.remove('is-open');
    });
  }
// Footer Accordion JS End

// Copy coupon code
document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
  copyBtn.addEventListener("click", function () {
    let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
    if (codeElement) {
      let codeText = codeElement.innerText.trim();
      navigator.clipboard.writeText(codeText).catch(err => {
        console.error("Copy failed", err);
      });
    }
  });
});

// Close bar
document.querySelectorAll(".discount-bar-close-icon").forEach(function (closeBtn) {
  closeBtn.addEventListener("click", function () {
    let bar = this.closest(".coupan-code");
    if (bar) {
      bar.style.display = "none";
    }
  });
});



// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}

function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {  
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });
}
function faq_toggle() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");  
      tabs_title.forEach(togal_tabs);
}
// faq tabs toggal end

// TAB JS CODE FOR FAQ

document.addEventListener("DOMContentLoaded", function () {

  const tabItems = document.querySelectorAll(".faq_tab_btn .tablinks");
  const panels = document.querySelectorAll(".panel");

  tabItems.forEach(tab => {
    tab.addEventListener("click", function () {

      const targetSelector = this.getAttribute("data-href");
      const targetPanel = document.querySelector(targetSelector);
      const anchor = this.querySelector("a");

      /* Remove active from all tabs & anchors */
      tabItems.forEach(item => {
        item.classList.remove("active");
        const a = item.querySelector("a");
        if (a) a.classList.remove("active");
      });

      /* Hide all panels */
      panels.forEach(panel => {
        panel.classList.add("hidden");
        panel.classList.remove("active");
      });

      /* Activate clicked tab */
      this.classList.add("active");
      if (anchor) anchor.classList.add("active");

      /* Show matching panel */
      if (targetPanel) {
        targetPanel.classList.remove("hidden");
        targetPanel.classList.add("active");
      }
    });
  });

});

const grid_change = document.querySelectorAll('[grid_change]');
const productGrid = document.querySelector('ul[data-product-main-wrapper]');

grid_change.forEach(item => {
  item.addEventListener("click", function () {
    const col = this.getAttribute('data_column');

    // Remove active from all buttons
    grid_change.forEach(btn => btn.classList.remove('active'));

    // Add active to clicked button
    this.classList.add('active');

    console.log("productGrid.className",productGrid.className)

    // Change grid class
    productGrid.className = productGrid.className.replace(
      /grid--\d+-col-tablet-down/g,
      `grid--${col}-col-tablet-down`
    );
  });
});

// faq tabs toggal end

(function () {
    collection_filter();
    faq_toggle();    
})();



document.querySelectorAll('.coll_scroll_to_desc').forEach(function(link) {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.getElementById('collection-desc-footer');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});


if (document.body.classList.contains('tmp-product')) {

  const url = window.location.href;

    if (url.includes('contact_posted=true#ContactForm-modal')) {
      const modal = document.querySelector('.custome_product_modal');
      if (modal) {
        modal.setAttribute('open', '');
      }
    }

}




const addToCart = document.querySelector('.quantity_selector_custom');
const body = document.querySelector('body');

let lastScrollY = window.scrollY;

if (addToCart && body) {
  const observer = new IntersectionObserver(([entry]) => {
    const scrollingDown = window.scrollY > lastScrollY;

    if (entry.isIntersecting && scrollingDown) {
      body.classList.add('is-sticky-atc');
    } else if (!entry.isIntersecting) {
      body.classList.remove('is-sticky-atc');
    }

    lastScrollY = window.scrollY;
  });

  observer.observe(addToCart);
}


